import ar from 'images/language-photos/ar@2x.jpg';
import cy from 'images/language-photos/cy@2x.jpg';
import da from 'images/language-photos/da@2x.jpg';
import de from 'images/language-photos/de@2x.jpg';
import el from 'images/language-photos/el@2x.jpg';
import en from 'images/language-photos/en@2x.jpg';
import enUs from 'images/language-photos/en-us@2x.jpg';
import es from 'images/language-photos/es@2x.jpg';
import esMx from 'images/language-photos/es-mx@2x.jpg';
import fa from 'images/language-photos/fa@2x.jpg';
import fr from 'images/language-photos/fr@2x.jpg';
import gl from 'images/language-photos/gl@2x.jpg';
import ha from 'images/language-photos/ha@2x.jpg';
import he from 'images/language-photos/he@2x.jpg';
import hi from 'images/language-photos/hi@2x.jpg';
import id from 'images/language-photos/id@2x.jpg';
import ig from 'images/language-photos/ig@2x.jpg';
import is from 'images/language-photos/is@2x.jpg';
import it from 'images/language-photos/it@2x.jpg';
import jpFull from 'images/language-photos/jp-full@2x.jpg';
import jpRomaji from 'images/language-photos/jp-romaji@2x.jpg';
import ko from 'images/language-photos/ko@2x.jpg';
import mn from 'images/language-photos/mn@2x.jpg';
import nl from 'images/language-photos/nl@2x.jpg';
import no from 'images/language-photos/no@2x.jpg';
import pl from 'images/language-photos/pl@2x.jpg';
import pt from 'images/language-photos/pt@2x.jpg';
import ptBr from 'images/language-photos/pt-br@2x.jpg';
import ru from 'images/language-photos/ru@2x.jpg';
import sl from 'images/language-photos/sl@2x.jpg';
import so from 'images/language-photos/so@2x.jpg';
import sv from 'images/language-photos/sv@2x.jpg';
import sw from 'images/language-photos/sw@2x.jpg';
import th from 'images/language-photos/th@2x.jpg';
import tl from 'images/language-photos/tl@2x.jpg';
import tr from 'images/language-photos/tr@2x.jpg';
import uk from 'images/language-photos/uk@2x.jpg';
import vi from 'images/language-photos/vi@2x.jpg';
import xh from 'images/language-photos/xh@2x.jpg';
import yo from 'images/language-photos/yo@2x.jpg';
import zhCn from 'images/language-photos/zh-cn@2x.jpg';

/** The keys need to match the locale returned by the backend */
const languageMap: Record<string, string | undefined> = {
  ar,
  cy,
  da,
  de,
  el,
  en,
  'en-us': enUs,
  es,
  'es-mx': esMx,
  fa,
  fr,
  gl,
  ha,
  he,
  hi,
  id,
  ig,
  is,
  it,
  'jp-full': jpFull,
  'jp-romaji': jpRomaji,
  ko,
  mn,
  nl,
  no,
  pl,
  pt,
  'pt-br': ptBr,
  ru,
  sl,
  so,
  sv,
  sw,
  th,
  tl,
  tr,
  uk,
  vi,
  xh,
  yo,
  'zh-cn': zhCn,
};

export function getLanguageImage(languageLocale: string): string | undefined {
  return languageMap[languageLocale];
}
